import React, { useState, useEffect } from "react";
import UseColors from "../staticQueries/useColors";

export const UseMatchedColors = (colorNames, product) => {
  const colors = UseColors();
  const [matchedColors, setMatchedColors] = useState([]);

  useEffect(() => {
    let matchedColorsArr = [];

    colors.forEach((color) => {
      if (product?.variants?.length && color) {
        const variant = product?.variants?.find((variant) =>
          String(variant.title)
            .toLowerCase()
            .includes(String(color?.name).toLowerCase())
        );
        if (variant?.media) {
          const media =
            product.media.find(
              (image) =>
                image.preview.image.originalSrc ===
                variant?.media[0]?.preview.image.originalSrc
            ) ?? variant.media[0];

          colorNames.forEach((colorName) => {
            if (color.name === colorName) {
              matchedColorsArr.push({
                ...color,
                imageUrl: media?.preview.image.originalSrc,
              });
            }
          });
        }
      }
    });

    setMatchedColors((prevState) => {
      const matchedColors = matchedColorsArr.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      if (JSON.stringify(prevState) !== JSON.stringify(matchedColors)) {
        return matchedColors;
      } else {
        return prevState;
      }
    });
  }, [product]);

  return [matchedColors];
};
export const UseSearchMatchedColors = (colorNames, product) => {
  const colors = UseColors();
  const [matchedColors, setMatchedColors] = useState([]);

  useEffect(() => {
    let matchedColorsArr = [];

    colors.forEach((color) => {
      if (product?.variants?.length && color) {
        const variant = product?.variants?.find((variant) =>
          String(variant.title)
            .toLowerCase()
            .includes(String(color?.name).toLowerCase())
        );
        if (variant?.image) {
          const media =
            product.media.find(
              (image) => image.originalSrc === variant?.image?.originalSrc
            ) ?? variant.image;

          colorNames.forEach((colorName) => {
            if (color.name === colorName) {
              matchedColorsArr.push({
                ...color,
                imageUrl: media?.originalSrc,
              });
            }
          });
        }
      }
    });

    setMatchedColors((prevState) => {
      const matchedColors = matchedColorsArr.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      if (JSON.stringify(prevState) !== JSON.stringify(matchedColors)) {
        return matchedColors;
      } else {
        return prevState;
      }
    });
  }, [product]);

  return [matchedColors];
};

export const UseMatchedColorsForSearch = (product) => {
  const colorsSet = new Set(
    product?.shopify_variants?.map(
      (option) => option?.options?.Color || option?.options?.Colour
    )
  );
  const uniqueColors = Array.from(colorsSet);

  const colors = UseColors();
  const [matchedColors, setMatchedColors] = useState([]);

  useEffect(() => {
    let matchedColorsArr = [];

    colors.forEach((color) => {
      uniqueColors.forEach((colorName) => {
        if (color.name === colorName) {
          matchedColorsArr.push(color);
        }
      });
    });

    setMatchedColors((prevState) => {
      const matchedColors = matchedColorsArr.sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      if (JSON.stringify(prevState) !== JSON.stringify(matchedColors)) {
        return matchedColors;
      } else {
        return prevState;
      }
    });
  }, [product]);

  return [matchedColors];
};
